import { computed, reactive } from 'vue';
import moment from 'moment-timezone';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronDown);

export default {
  name: 'EventSessionsItemComponent',
  props: {
    session: {
      type: Object,
      required: true,
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
    showJoinButtons: {
      type: Boolean,
      required: false,
      default: true,
    },
    columns: {
      type: Number,
      required: false,
      default: 1,
    },
    showDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    dayColumnStyle: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: { moment, FontAwesomeIcon },
  emits: ['toggled'],
  setup(props) {

    const state = reactive({
      session: props.session,
      open: props.open,
      instructorText: computed(() => {
        if (props.session.session_instructors.length) {
          return formatInstructorArray(props.session.session_instructors);
        } else if (props.session.instructors !== null && props.session.instructors !== '') {
          return props.session.instructors;
        }
        return false;

      }),
      timeText: computed(() => {
        return formatSessionTimes(props.session.starts_at, props.session.expires_at);
      }),
      dateText: computed(() => {
        return formatSessionDate(props.session.starts_at);
      }),
      trackText: computed(() => {
        return !state.isBreak && props.session.trackName ? `| ${props.session.trackName}` : '';
      }),
      url: computed(() => {
        if (props.session.url) {
          return props.session.url;
        }
        return false;
      }),
      isExpired: computed(() => {
        let now = new Date();
        let endDate = new Date(props.session.expires_at);

        return (now > endDate);
      }),
      btnText: computed(() => {
        if (state.isExpired) {
          return 'Session Over';
        }

        return 'Join Session';
      }),
      hasDescription: computed(() => {
        if (props.session.description !== null && props.session.description !== '') {
          return true;
        }

        return false;
      }),
      styleObject: computed(() => {
        return {
          borderLeft: '5px solid ' + props.color,
          flexBasis: (100 / props.columns) + '%',
        };
      }),
      titleStyleObject: computed(() => {
        return {
          color: props.color,
          marginBottom: '4px',
        };
      }),
      isBreak: computed( () => {
        return props.session.is_schedule_break;
      }),
      dynamicTitleStyle: computed( () => {
        if(state.isBreak) {
          return {
            color: props.color,
          };
        } else {
          return null;
        }
      }),
    });

    const formatSessionTimes = (start, end) => {
      let startDate = new Date(start);
      let endDate = new Date(end);
      let startTimeString = formatAMPM(startDate);
      let endTimeString = formatAMPM(endDate);
      let zone = moment.tz.guess();
      let zoneName = moment().tz(zone).zoneAbbr();
      return startTimeString + ' - ' + endTimeString + ' ' + zoneName;
    };

    const formatSessionDate = (dateString) => {
      let date = new Date(dateString);
      var day = date.getDate();
      var year = date.getFullYear();
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var month = monthNames[date.getMonth()];
      var string = month + '. ' + day + ', ' + year;
      return string;
    };

    const formatAMPM = (dateObj) => {
      let hours = dateObj.getHours();
      let minutes = dateObj.getMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    };

    const formatInstructorArray = (array) => {
      if (1 === array.length) {
        return array[0]['title'];
      } else {
        let text = '';
        for (let i = 0; i < array.length; i++) {
          if (i === array.length - 2) {
            text += array[i]['title'] + ' & ';
          } else if (i === array.length - 1) {
            text += array[i]['title'];
          } else {
            text += array[i]['title'] + ', ';
          }
        }
        return text;
      }

    };

    return { state, formatSessionTimes, formatSessionDate };
  },
  methods: {
    close: async function() {
      this.state.open = false;
      this.$emit('toggled', this.state.open);
    },
    toggle: async function() {
      this.state.open = !this.state.open;
      this.$emit('toggled', this.state.open);
    },
    openSession: async function(url) {
      window.open(url, '_blank');
    },
  },
};
